import { APP_CONFIG } from "../config/runtime-config";
const AUTH_CLIENT_ID = APP_CONFIG.AUTH_CLIENT_ID;
const AUTH_SCOPE = APP_CONFIG.AUTH_SCOPE;
export const msalConfig = {
    auth: {
        clientId: AUTH_CLIENT_ID !== null && AUTH_CLIENT_ID !== void 0 ? AUTH_CLIENT_ID : "",
        authority: `https://login.microsoftonline.com/${APP_CONFIG.AUTH_TENANT_ID || "common"}`,
        redirectUri: APP_CONFIG.AUTH_REDIRECT_URI || "/ms-redirect",
        postLogoutRedirectUri: APP_CONFIG.AUTH_LOGOUT_REDIRECT_URI || "/",
    },
    cache: {
        cacheLocation: "sessionStorage",
    },
};
export const loginRequest = {
    scopes: [AUTH_SCOPE !== null && AUTH_SCOPE !== void 0 ? AUTH_SCOPE : ""],
};
